import React from 'react';
import { ColumnDef, Table } from '@g17eco/molecules/table';
import { TableColumn } from '@g17eco/types/universalTracker';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

interface Props {
  columns: TableColumn[];
  onEdit: (code: string) => void;
  onDelete: (code: string) => void;
  isAnswered: boolean;
}

export const ColumnSummaryTable = ({ columns, onEdit, onDelete, isAnswered }: Props) => {
  const tableColumns: ColumnDef<TableColumn>[] = [
    {
      accessorKey: 'code',
      header: 'CODE',
    },
    {
      accessorKey: 'type',
      header: 'TYPE',
    },
    {
      accessorKey: 'name',
      header: 'COLUMN NAME',
    },
    {
      accessorKey: 'unitType',
      header: 'UNIT TYPE',
    },
    {
      accessorKey: 'unit',
      header: 'UNIT',
    },
    {
      accessorKey: 'numberScale',
      header: 'NUMSCALE',
    },
    {
      id: 'actions',
      header: '',
      enableSorting: false,
      meta: {
        cellProps: {
          className: 'text-right text-nowrap',
        },
      },
      cell: ({ row }) => {
        return (
          <UncontrolledDropdown>
            <DropdownToggle
              outline
              color='transparent'
              className='border-ThemeNeutralsLight px-2'
              data-testid={`column-dropdown-toggle-${row.original.code}`}
            >
              <i className={'fal fa-bars'} />
            </DropdownToggle>
            <DropdownMenu right container='body' className='border-ThemeBorderDefault'>
              <DropdownItem onClick={() => onEdit(row.original.code)}>
                <i className='fal fa-pencil mr-2' />
                Edit column
              </DropdownItem>
              <DropdownItem onClick={() => onDelete(row.original.code)} disabled={isAnswered} className='text-danger'>
                <i className='fal fa-trash mr-2 text-ThemeDangerMedium' />
                Delete column
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        );
      },
    },
  ];

  if (columns.length === 0) {
    return null;
  }

  return (
    <div className='mt-4'>
      <Table columns={tableColumns} data={columns} pageSize={10} />
    </div>
  );
};
